const initialState = {
  bed_type_options: [],
  error: ""
}

export default function bedTypes(state = initialState, action){
  switch(action.type) {
  case 'BED_TYPE_OPTIONS':
    return Object.assign({}, state, { bed_type_options: action.result })
  case 'BED_TYPE_ERROR':
    return Object.assign({}, state, { error: action.message })
  default:
    return state
  }
}
